/**
 * FireGuard Live - API Service Wrapper
 * - По подразбиране винаги се ползва реално API (вкл. на app.firesguard.net).
 * - Демо режим само при REACT_APP_DEMO_MODE=true или ?demo=1 в URL.
 */
import {
  authAPI,
  devicesAPI,
  monitoringAPI,
  maintenanceAPI,
  inspectionsAPI,
  sprinklerMonitorAPI,
  electricalPanelMonitorAPI,
  evacDoorMonitorAPI
} from './api';
import { demoApiService } from './demoApiService';

const realApiService = {
  auth: authAPI,
  devices: devicesAPI,
  monitoring: monitoringAPI,
  maintenance: maintenanceAPI,
  inspections: inspectionsAPI,
  sprinklerMonitor: sprinklerMonitorAPI,
  electricalPanelMonitor: electricalPanelMonitorAPI,
  evacDoorMonitor: evacDoorMonitorAPI,
  ai: {}
};

export function getIsDemoMode() {
  if (typeof window === 'undefined' || !window.location) return false;
  const forced = process.env.REACT_APP_DEMO_MODE === 'true' || /[?&]demo=1/.test(window.location.search || '');
  return !!forced;
}

// Избор при всяко достъпване – така на сървъра винаги се ползва демо
const apiServiceProxy = new Proxy(realApiService, {
  get(_, prop) {
    return (getIsDemoMode() ? demoApiService : realApiService)[prop];
  }
});

export const apiService = apiServiceProxy;
export default apiService;